module.exports = __webpack_public_path__ + "img/29.5c625634.png";